import React from "react";
import "../styles/NotFound.css";

const NotFound = () => {

  return (
    <div className="nf-container">
      <div className="nf-card">
        <div className="nf-code">404</div>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-text">
          The page you’re looking for doesn’t exist or was moved.
        </p>

        <div className="nf-actions">
          <button
            onClick={() => window.location.assign("https://bleepshare.com/")}
            className="nf-btn secondary"
          >
            Go Bleepshare
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
